import * as React from 'react'
import Slider, { Settings as SliderSettings } from 'react-slick'
import classNames from 'classnames'
import { breakpointStore } from '../../../stores'
import './product-gallery.scss'
import { SliderArrow } from '../../shared/slider-arrow'
import { observer } from 'mobx-react'

interface IProps {
  images: string[]
  overflow?: 'left' // equivalent of 'right' by default
}

interface IState {
  initialised: boolean
}

@observer
export class ProductGallery extends React.Component<IProps, IState> {
  state: IState = { initialised: false }

  componentDidMount(): void {
    this.setState({ initialised: true })
  }

  get aboveMd(): boolean {
    return breakpointStore.breakpoint.above.md
  }

  get slides(): string[] {
    const { images, overflow } = this.props

    if (overflow === 'left') {
      return images
    }

    return images.reverse()
  }

  render(): React.ReactNode {
    const { overflow, initialised } = { ...this.props, ...this.state }

    const classes: string = classNames(
      'product-gallery',
      { 'product-gallery--initialized': initialised },
      { [`product-gallery--overflow product-gallery--overflow--${overflow}`]: overflow }
    )

    const sliderSettings: SliderSettings = {
      dots: true,
      arrows: this.aboveMd ? (this.slides.length > 1 ? true : false) : false,
      infinite: this.slides.length > 1,
      speed: 500,
      autoplay: false,
      slidesToShow: 1,
      slidesToScroll: 1,
      prevArrow: <SliderArrow direction='left' />,
      nextArrow: <SliderArrow direction='right' />
    }

    return (
      <div className={classes}>
        <div className='product-gallery__inner'>
          <div className='product-gallery__images'>
            <Slider {...sliderSettings}>
              {this.slides.map(
                (image: string, i: number): React.ReactNode => (
                  <div className='product-gallery__slide' key={i}>
                    <div className='product-gallery__image' style={{ backgroundImage: `url('${image}')` }} />
                  </div>
                )
              )}
            </Slider>
          </div>
        </div>
      </div>
    )
  }
}
